// Lista de conversas salvas do usuário: busca ao montar e ao abrir o chat.
import { useCallback, useEffect, useState } from "react";
import { listarConversas } from "./conversas";

export function useListaDeConversas(aberto) {
  const [lista, setLista] = useState([]);
  const [erro, setErro] = useState("");

  const recarregar = useCallback(() => {
    void listarConversas().then(
      (d) => {
        setErro("");
        setLista(Array.isArray(d?.conversas) ? d.conversas : []);
      },
      (e) => setErro(e instanceof Error ? e.message : "Não foi possível carregar suas conversas."),
    );
  }, []);

  useEffect(() => {
    if (aberto) recarregar();
  }, [aberto, recarregar]);
  useEffect(() => {
    recarregar();
  }, [recarregar]);

  return { lista, erro, recarregar };
}
